import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { MoneySourceInsertService } from '../../service/money-source-insert/money-source-insert.service';

@Component({
	selector: 'app-money-source-insert',
	templateUrl: './money-source-insert.component.html',
	providers: [
		MoneySourceInsertService,
		HttpModule
	]
})
export class MoneySourceInsertComponent implements OnInit {

	private token;
	moneySource: FormGroup;
	Nome: string = "";
	statusMoneySource: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private moneySourceInsertService: MoneySourceInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.moneySource = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addMoneySource(value: any) {
		this.moneySourceInsertService.insertMoneySource(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/origem-recurso');

		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/origem-recurso');
	}

}



// WEBPACK FOOTER //
// ./src/app/money-source/component/money-source-insert/money-source-insert.component.ts